import { useLocation, Outlet } from "react-router-dom";
// @mui
import { Box, Link, Container, Typography, Stack } from "@mui/material";
// components
import { useLocales } from "../../locales";
import Logo from "../../components/logo";
import Header from "../dashboard/header";

// ----------------------------------------------------------------------

export default function HotelLayout() {
    const { pathname } = useLocation();

    const { translate } = useLocales();

    return (
        <Stack sx={{ minHeight: 1, background: "#070707" }}>
            <Header/>
            <Outlet />

            <Box sx={{ flexGrow: 1 }} />

            <Box
                sx={{
                    py: 5,
                    textAlign: "center",
                    position: "relative",
                    bgcolor: "background.default",
                }}
            >
                <Container>
                    <Logo sx={{ mb: 1, mx: "auto" }} />

                    <Typography variant="caption" component="p">
                        © {translate("landingPage.allRightsReserved")}
                        <br /> {translate("landingPage.madeBy")} &nbsp;
                        <Link
                            href="https://nightz.app/"
                            sx={{
                                color: "#ffffff",
                            }}
                        >
                            nightz.app
                        </Link>
                    </Typography>
                </Container>
            </Box>
        </Stack>
    );
}
